import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-20 bg-neutral/5">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-10"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
              About Us
            </h2>
            <div className="w-24 h-1 bg-accent mx-auto"></div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed font-light"
          >
            <p>
              We specialize in designing and building custom cabinetry throughout your entire home — from kitchens and bathrooms to walk-in closets, garage cabinets, and complete storage systems.
            </p>
            <p>
              Our passion is craftsmanship. Every project is tailored to your exact space, needs, and lifestyle.
            </p>
            <p>
              We combine functionality, organization, and refined aesthetics to create spaces that are both beautiful and practical.
            </p>
            <p className="font-medium text-primary">
              At Source Cabinetry, everything is fully customized — no standard solutions, only precision-built results.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
